import { TranslatableKey } from '@app/types/translatable.type';
import { Role } from '@models/account/role.model';

export function getRoleAccessLevelDescription(role: Role): TranslatableKey {
    const includesPermission = (permission: string): boolean =>
        role.permissions.map((permissionModel) => permissionModel.name).includes(permission);

    if (includesPermission('manageAll')) {
        return 'forms.change-requests.accessLevel.PERMISSION.manageAll';
    }

    if (includesPermission('manageDirectAndIndirectReports')) {
        return 'forms.change-requests.accessLevel.PERMISSION.manageDirectAndIndirectReports';
    }

    if (includesPermission('manageDirectReports')) {
        return 'forms.change-requests.accessLevel.PERMISSION.manageDirectReports';
    }

    if (includesPermission('manageSelf')) {
        return 'forms.change-requests.accessLevel.PERMISSION.manageSelf';
    }

    return '';
}
